<h1 matDialogTitle>
  {{ 'Choose a pool for Apps' | translate }}
</h1>
<form class="ix-form-container" [formGroup]="form" (submit)="onSubmit()">
  <ix-select
    formControlName="pool"
    [label]="'Pool' | translate"
    [required]="true"
    [options]="pools$"
  ></ix-select>

  <ix-checkbox
    *ngIf="canMigrateApplications"
    formControlName="migrateApplications"
    [label]="'Migrate applications to the new pool' | translate"
  ></ix-checkbox>

  <div class="form-actions">
    <button mat-button type="button" [matDialogClose]="false">
      {{ 'Cancel' | translate }}
    </button>

    <button mat-button type="submit" color="primary" [disabled]="form.invalid">
      {{ 'Choose' | translate }}
    </button>
  </div>
</form>
